import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, Zap } from 'lucide-react';
import { Button } from './Button';
export function HeroSection() {
  return <section className="pt-20 pb-10 sm:pt-32 sm:pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-124">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-125">
        

        <h1 className="text-2xl sm:text-4xl md:text-5xl font-black text-white leading-tight mb-4 sm:mb-6 drop-shadow-lg uppercase max-w-4xl mx-auto" data-id="element-126">
          VENDÉ POR INTERNET CON IA, ANUNCIOS Y WHATSAPP
        </h1>

        <p className="text-lg sm:text-2xl text-yellow-300 font-bold mb-6 drop-shadow max-w-3xl mx-auto" data-id="element-127">
          Método Venta Flash IA — 5 tomos + 3 bonos para emprendedores que
          quieren vender con un sistema claro y aplicable.
        </p>

        {/* Mockup Image */}
        <div className="my-5 sm:my-10 mx-auto max-w-sm sm:max-w-lg md:max-w-2xl" data-id="element-128">
          <img src="https://cdn.magicpatterns.com/uploads/ck6JD4t8vZBivG7qjtH2cp/hf_20260402_002016_7e061ebc-c2cc-4501-a357-46221eea29d7.png" alt="Método Venta Flash IA — Mega Pack: 5 Tomos + 3 Bonos" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-129" />
        </div>

        <p className="text-lg sm:text-xl text-white/90 font-medium mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow" data-id="element-130">
          Aprendé a organizar tu oferta, crear anuncios, usar inteligencia
          artificial y cerrar ventas por WhatsApp con un sistema claro, paso a
          paso y listo para aplicar.
        </p>

        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-8 mb-8 sm:mb-10 text-left sm:text-center max-w-4xl mx-auto" data-id="element-131">
          {['100% PDF · Acceso inmediato', 'Sin experiencia previa', 'Funciona para productos y servicios'].map((item, i) => <div key={i} className="flex items-center gap-2 text-white font-medium" data-id="element-132">
              <CheckCircle2 className="w-5 h-5 text-yellow-300 shrink-0" data-id="element-133" />
              <span data-id="element-134">{item}</span>
            </div>)}
        </div>

        <div className="max-w-md mx-auto" data-id="element-135">
          <Button href="https://checkout.guiadigital360.online/cart/44839939866693:1" className="w-full text-xl py-5 mb-4" data-id="element-136">
            QUIERO MI MEGA PACK AHORA <Zap className="w-5 h-5" data-id="element-137" />
          </Button>

          <div className="flex items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm text-white/80 font-medium flex-wrap" data-id="element-138">
            <span className="flex items-center gap-1" data-id="element-139">Pago seguro</span>
            <span data-id="element-140">·</span>
            <span className="flex items-center gap-1" data-id="element-141">Acceso inmediato</span>
            <span data-id="element-142">·</span>
            <div className="flex items-center gap-2" data-id="element-143">
              <img src="https://cdn.magicpatterns.com/uploads/opopvYnrBHowmrFF4LaJuL/jo3l6snt.png" alt="Garantía 7 días de reembolso" className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-144" />
              <span data-id="element-145">Garantía de 7 días</span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}